module.exports = __webpack_public_path__ + "media/images/logo/logo_auto-9937e4b33ec0ae92ba3fc169bbf9de78.svg";